import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'sidebar-watchlists',
  templateUrl: 'sidebar-watchlists.html'
})
export class SidebarWatchlistsComponent {
  @Input() sectors: any = [];
  @Input() regions: any = [];
  @Input() filter: any;
  @Input() filterName: any;
  @Output() updateFilter: EventEmitter<any> = new EventEmitter();
  @Input() sidebar: string;

  defaultFilter: any = { name: 'Personal', ref: 'personal', config: { sort: {}, filter: { sector: 'All Sectors', industry: 'All Industries', region: 'All regions' } } };
  _filter: Observable<any>;

  constructor() {
    this._filter = new Subject();
  }

  _updateFilter($event) {
    this.updateFilter.emit(this.filter);
  }

  ngOnInit() {
    this.init();
  }
  ngOnChanges() {
    this.init();
  }

  init() {
    if (!this.filter) return;
    this.filter = Object.assign(this.defaultFilter, this.filter);
    if(!this.filter.screens){
      this.filter.screens = {};
    }
    this._filter = new Observable(observer => {
      observer.next(Object.assign({},this.filter));
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebar-watchlists/sidebar-watchlists.ts